"use client";

import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger, DialogClose, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { cn } from "@/lib/utils";
function FullScreenMenu({
  onItemClick
}: {
  onItemClick: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="25555" className="flex flex-col gap-6 items-center animate-pulse">
        <div className="h-8 w-32 bg-muted rounded-md" />
        <div className="h-8 w-48 bg-muted rounded-md" />
        <div className="h-8 w-40 bg-muted rounded-md" />
      </div>;
  }
  if (!menuItems || menuItems.length === 0) return null;
  return <nav className="flex flex-col items-center gap-6 md:gap-8">
      {menuItems.map((item, i) => <div key={item.id} data-index={i} className="group relative overflow-hidden">
          <Link to={item.href || "#"} className="text-3xl md:text-5xl font-serif font-bold text-[#182329] hover:text-[#1AAD4A] transition-colors duration-300 block py-2" onClick={onItemClick}>
            {item.label}
          </Link>
        </div>)}
    </nav>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="hoofdnavigatie" className={cn("sticky top-0 z-50 w-full transition-all duration-300 ease-in-out", isScrolled ? "bg-white/80 backdrop-blur-md border-b border-[#DCDFE0] shadow-sm" : "bg-white")}>
      <div className="container mx-auto px-6 h-20 flex items-center justify-between">
        {}
        <Link to="/" className="flex items-center shrink-0 z-50">
          <img src="https://nice-frog.10web.cloud/wp-content/uploads/2026/03/Scherm­afbeelding-2026-03-26-om-12.54.43.png" alt="offerte aanvragen" className="h-9 w-auto object-contain" />
        </Link>

        {}
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
          <DialogTrigger asChild>
            
          </DialogTrigger>

          {}
          
        </Dialog>
      </div>
    </header>;
}